import * as ParamActions from '../actions/param.action';
import { DeclIrSefParamsDTO } from './../dominios/DTO/declIrSef-árams.DTO';


export const param: DeclIrSefParamsDTO = new DeclIrSefParamsDTO();

export function paramReducer(state = param, action: ParamActions.Actions) {
    switch (action.type) {
        case ParamActions.ADD_PARAM:
            {
                state = action.payload;
                return state;
            };

        case ParamActions.CLEAR_PARAM:
            {
                state = new DeclIrSefParamsDTO();
                return state;
            }

        default:
            return state;
        }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/reducers/param.reducer.ts